import { render, staticRenderFns } from "./LooxScheduled.vue?vue&type=template&id=87d23c78&scoped=true&"
import script from "./LooxScheduled.vue?vue&type=script&lang=js&"
export * from "./LooxScheduled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d23c78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/whatsapp-crm-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87d23c78')) {
      api.createRecord('87d23c78', component.options)
    } else {
      api.reload('87d23c78', component.options)
    }
    module.hot.accept("./LooxScheduled.vue?vue&type=template&id=87d23c78&scoped=true&", function () {
      api.rerender('87d23c78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Integrations/loox/LooxScheduled.vue"
export default component.exports